import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
	SypacButton,
	SypacIcon,
	SypacText,
} from '@sypac/component-library-react';
import { useTranslate } from '@tolgee/react';
import { cn } from '../../lib/utils';

interface OpenOrderPageButtonProps {
	orderId: number;
	iconOnly?: boolean;
}

const OpenOrderPageButton: React.FC<OpenOrderPageButtonProps> = ({
	orderId,
	iconOnly = false,
}) => {
	const { t } = useTranslate();
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const path = `/orders/${orderId}`;

	if (pathname === path) return null;

	const label = t('orderPage.trackOrder', 'Track order');

	return (
		<SypacButton variant="secondary" size="small" className="flex-none">
			<button
				type="button"
				onClick={() => navigate(path)}
				title={iconOnly ? label : undefined}
				aria-label={iconOnly ? label : undefined}
				className={cn(
					'h-[40px] rounded-lg flex gap-2 items-center border-none bg-alabaster text-gray-80 transition hover:bg-gray-10 cursor-pointer',
					iconOnly ? 'w-[40px] px-0 justify-center' : 'px-3',
				)}
			>
				<SypacIcon
					iconName="Map"
					size="custom"
					width="22px"
					height="22px"
					className="mb-[2px]"
				/>
				{!iconOnly ? (
					<SypacText variant="body-regular-medium">
						<p>{label}</p>
					</SypacText>
				) : null}
			</button>
		</SypacButton>
	);
};

export default OpenOrderPageButton;
